import { useToggle } from 'usehooks-ts'
import { useEffect } from 'react'
import { Action } from '@weblite/logic-toolkit'
import { useHallAdminsCount } from '$logic/subscription/react-hook'
import { ProfileActionItem } from '$common/profile-action-item'
import { AdministratorIcon } from '$common/icons'
import { openHallAdmins } from '$logic/router'
import { toLocale } from '$func/text'
import { t } from '$i18n'

export const updateHallAdminsCountAction = new Action<void>()

export function HallAdminsActionItem({ hallId }: { hallId: string }) {
  const [reloadAdminCount, triggerReloadAdminCount] = useToggle()

  useEffect(() => updateHallAdminsCountAction.add(triggerReloadAdminCount), [])

  const { count, loading } = useHallAdminsCount(hallId, reloadAdminCount)

  return (
    <ProfileActionItem
      Icon={<AdministratorIcon />}
      onClick={() => openHallAdmins(hallId)}
      secondaryText={toLocale(count)}
      secondaryTextLoading={loading}
    >
      {t('profile.hall.actions.admins')}
    </ProfileActionItem>
  )
}
